"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#545250";
const headerBackgroundColor = "#FFFFFF";
const headerTextColor = brand;
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const fontFamily = `
@font-face {
    font-family:    "libre-baskerville";
    src:            url("/fonts/libre-baskerville/libre-baskerville.ttf") format('truetype');
    font-weight:    normal;
    font-style:     normal;
}
html {
    font-family: "libre-baskerville", sans-serif;
}
`;
exports.default = {
    fontFamily,
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    style,
};
